import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import { calculateCourseDateCombined } from "@shared/lib/course-date-combined"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type ModalManager from "cc-frontend/services/modal-manager"
import type PhantomCardStacks from "cc-frontend/services/phantom-card-stacks"
import { toLeft, toRight } from "ember-animated/transitions/move-over"
import { filter } from "lodash-es"
import styles from "./add-menu.module.css"

@tagName("")
export default class AddMenu extends Component {
  readonly styles = styles
  //component args
  onCourseCreate!: Function
  planbook!: Planbook
  courses!: Array<Course>
  rotationCalendar!: RotationCalendar
  dateString!: string
  closeMenu!: () => void

  // Props
  isShowingPrimaryMenu: boolean = true

  @service rpc
  @service declare phantomCardStacks: PhantomCardStacks
  @service declare modalManager: ModalManager

  // Ember-animated related stuff
  toLeft = toLeft
  toRight = toRight

  animationRules({ newItems }) {
    let newVal = newItems[0]
    if (newVal === true) {
      return toRight
    } else {
      return toLeft
    }
  }

  animationRulesForSecondaryMenu({ newItems }) {
    let newVal = newItems[0]
    if (newVal === true) {
      return toLeft
    } else {
      return toRight
    }
  }

  @computed("courses.length", "dateString")
  get offCourses() {
    return filter(this.courses, (course) => {
      let cd = calculateCourseDateCombined(
        this.dateString,
        course,
        this.planbook,
        this.rotationCalendar,
        (courseId, dateString) =>
          this.phantomCardStacks.findCardStackIdForDate(courseId, dateString)
      )
      return cd.isOff
    })
  }

  //Actions
  @action
  showToggleClassesOnOffMenu() {
    this.set("isShowingPrimaryMenu", false)
  }

  @action
  onToggle() {
    this.set("isShowingPrimaryMenu", false)
  }

  @action goToSettingsCourses() {
    this.closeMenu()
    this.modalManager.openModal("planner/planbook/create-edit/edit-modal", {
      planbook: this.planbook,
      rotationCalendar: this.rotationCalendar,
      screen: "STATE_COURSES_EDITOR",
    })
  }
}
